<app-navigation-layout [hideMenu]="true">
  <span main-container>
    <section class="row m-0">
      <div class="col-12">
        <app-booking-order-title></app-booking-order-title>
      </div>
      <section class="col-12">
        <app-current-basket-view></app-current-basket-view>
      </section>
    </section>
  </span>
  <span navigation-container>
    <app-backward-forward (forwardClick)="onNext()" (backwardClick)="onBack()">
    </app-backward-forward>
  </span>
</app-navigation-layout>
